import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { SALES_ARGS, FAQ_ITEMS, CONTACT } from "../../mock/mockData";

const SalesAndFaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <>
      {/* 07 Sales args */}
      <section className="border-t-[3px] border-black bg-[#F4F0E8]">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-24">
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-5">
              <span className="mono text-[11px] uppercase tracking-widest px-3 py-1 brut-border bg-white">07</span>
              <span className="mono text-[11px] uppercase tracking-widest text-black/60">Argumentos de venda</span>
              <div className="flex-1 h-[3px] bg-black" />
            </div>
            <h2 className="display font-bold text-[36px] sm:text-[56px] md:text-[80px] lg:text-[96px] leading-[0.9]">
              Seis frases
              <br />
              para <span className="italic font-normal">fechar</span> a venda.
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-0 brut-border-thick bg-black">
            {SALES_ARGS.map((s, i) => {
              const tones = [
                "bg-white",
                "bg-[#FFD60A]",
                "bg-white",
                "bg-[#E63946] text-white",
                "bg-white",
                "bg-black text-[#FFD60A]",
              ];
              const tone = tones[i % tones.length];
              return (
                <div
                  key={s.num}
                  className={`p-6 md:p-8 ${tone} ${i > 0 ? "border-l-0 sm:border-l-[3px] lg:border-l-[3px] border-black" : ""} ${
                    i % 2 === 1 && i < 5 ? "sm:border-l-[3px]" : ""
                  } ${i >= 2 ? "border-t-[3px] border-black" : ""} ${
                    i >= 3 && "lg:border-t-[3px]"
                  }`}
                >
                  <div className="flex items-center justify-between mb-4">
                    <span className="display text-[28px] font-bold">{s.num}</span>
                    <span className={`mono text-[10px] uppercase tracking-widest ${tone.includes("text-white") || tone.includes("text-[#FFD60A]") ? "opacity-80" : "text-black/60"}`}>
                      Argumento
                    </span>
                  </div>
                  <h3 className="display text-[20px] md:text-[24px] font-bold leading-[1.1]" dangerouslySetInnerHTML={{ __html: s.title.replace(/\b(100% lítio|1 ano|vida útil real|gratuito|Suporte local|\+537 €)\b/g, "<em class='italic font-normal underline decoration-2 underline-offset-2'>$1</em>") }} />
                  <p className={`mt-3 text-[13px] leading-[1.5] ${tone.includes("text-white") || tone.includes("text-[#FFD60A]") ? "" : "text-black/80"}`}>
                    {s.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* 08 FAQ */}
      <section id="faq" className="border-t-[3px] border-black bg-white">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-24">
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-5">
              <span className="mono text-[11px] uppercase tracking-widest px-3 py-1 brut-border bg-white">08</span>
              <span className="mono text-[11px] uppercase tracking-widest text-black/60">FAQ Revendedor</span>
              <div className="flex-1 h-[3px] bg-black" />
            </div>
            <h2 className="display font-bold text-[36px] sm:text-[56px] md:text-[80px] lg:text-[96px] leading-[0.9]">
              Tudo o que
              <br />
              <span className="italic font-normal">um revendedor</span>
              <br />
              pergunta.
            </h2>
          </div>

          <div className="grid lg:grid-cols-[1fr_1.5fr] gap-10">
            <div className="space-y-4 h-fit lg:sticky lg:top-28">
              <div className="brut-border bg-[#FFD60A] p-6 md:p-8">
                <div className="mono text-[11px] uppercase tracking-widest font-bold">Ainda com dúvidas?</div>
                <div className="display text-[34px] md:text-[36px] font-bold leading-tight mt-3">
                  Liga directamente para Vagos.
                </div>
                <a
                  href="tel:+351928272818"
                  className="mt-6 inline-flex items-center gap-3 bg-black text-[#FFD60A] font-bold mono text-[13px] uppercase tracking-wider px-5 py-4 brut-border brut-btn"
                >
                  {CONTACT.phone}
                </a>
              </div>
              <div className="brut-border bg-white p-6 md:p-8">
                <div className="mono text-[11px] uppercase tracking-widest font-bold text-black/60">Loja Lisboa</div>
                <div className="display text-[30px] md:text-[34px] font-bold leading-tight mt-3">
                  Fala directamente com Lisboa.
                </div>
                <a
                  href="tel:+351928274008"
                  className="mt-6 inline-flex items-center gap-3 bg-black text-[#FFD60A] font-bold mono text-[13px] uppercase tracking-wider px-5 py-4 brut-border brut-btn"
                >
                  {CONTACT.lisbonPhone}
                </a>
              </div>
            </div>

            <div className="space-y-0 brut-border-thick bg-[#F4F0E8]">
              {FAQ_ITEMS.map((item, i) => (
                <div key={i} className={`${i > 0 ? "border-t-[3px] border-black" : ""}`}>
                  <button
                    onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                    className="w-full flex items-center justify-between text-left px-5 md:px-7 py-5 hover:bg-white transition-colors"
                  >
                    <span className="display text-[18px] md:text-[22px] font-bold pr-4 leading-tight">{item.q}</span>
                    <span className="w-10 h-10 brut-border bg-white grid place-items-center flex-shrink-0">
                      {openIndex === i ? <Minus size={18} /> : <Plus size={18} />}
                    </span>
                  </button>
                  {openIndex === i && (
                    <div className="px-5 md:px-7 pb-6 -mt-1">
                      <p className="text-[14px] md:text-[15px] leading-[1.6] text-black/80 max-w-[640px]">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SalesAndFaq;
